export const ENTERPRISE_LOOKUP_PATH = '/enterprise-lookup';
